import { IPublicClientApplication } from '@azure/msal-browser';
import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { ConnectionErrorController } from '../connectionErrorController';
import onBeforeRequest from './onBeforeRequest';
import onResponseError from './onResponseError';

export interface InterceptorArgs {
    msalInstance: IPublicClientApplication;
}

/**
 * Setup Axios interceptors for automatic token management
 */
export function setupAxiosInterceptors(
    axiosInstance: AxiosInstance,
    args: InterceptorArgs
) {
    const connectionErrorController = ConnectionErrorController();

    axiosInstance.interceptors.request.use(
        async (config: InternalAxiosRequestConfig) => {
            await onBeforeRequest(args, config);

            return config;
        },
        (error) => Promise.reject(error)
    );

    axiosInstance.interceptors.response.use(
        (response) => {
            connectionErrorController.onSuccess();

            return response;
        },
        async (error) => {
            return await onResponseError(args, axiosInstance, error);
        }
    );
}
